import { FC } from "react";
import { MinusOutlined} from "@ant-design/icons";
import reportIcon from "../../assets/img/reportIcon.svg";
import tokenIcon from "../../assets/img/tokenIcon.svg";
import reprintIcon from "../../assets/img/reprint-tokenIcon.svg";
import boltIcon from "../../assets/img/boltCircle.svg";
import { getSavedState } from "../../services/localStorage";

import "./content.css";
 
import { localStorageKeys, USER_TYPE } from "../Utils/constants";
import AdminContentLayout from "./AdminContentLayout";
import SelfServiceContentLayout from "./SelfServiceLayout";
import { ContentLayoutProps } from "./types";

const items = [
  {
    key: "1",
    icon: <img src={tokenIcon} alt="" />,
    label: (
      <a href="/token" rel="noopener noreferrer">
        Token
      </a>
    ),
  },
  {
    key: "2",
    icon: <img src={reprintIcon} alt="" />,
    label: (
      <a href="/reprint-credit-token" rel="noopener noreferrer">
        Re-print Credit Token
      </a>
    ),
  },
  {
    key: "3",
    icon: <img src={boltIcon} alt="" />,
    label: (
      <a href="/special-tokens" rel="noopener noreferrer">
        Special Tokens
      </a>
    ),
  },
];
const reportItems = [
  {
    key: "5",
    label: "Reports",
    icon: <img src={reportIcon} alt="Reports Icon" />,
    children: [
      {
        key: "5-1",
        icon: <MinusOutlined style={{ transform: "rotate(90deg)" }} />,
        label: (
          <a href="/report/audit-log" rel="noopener noreferrer">
            Audit log
          </a>
        ),
      },
      {
        key: "5-2",
        icon: <MinusOutlined style={{ transform: "rotate(90deg)" }} />,
        label: (
          <a href="/report/customer-population" rel="noopener noreferrer">
            Customer population
          </a>
        ),
      },
      {
        key: "5-3",
        icon: <MinusOutlined style={{ transform: "rotate(90deg)" }} />,
        label: (
          <a href="/report/customer-setup" rel="noopener noreferrer">
            Customer setup
          </a>
        ),
      },
      {
        key: "5-4",
        icon: <MinusOutlined style={{ transform: "rotate(90deg)" }} />,
        label: (
          <a href="/report/daily-sales-point" rel="noopener noreferrer">
            Daily sales by sales point
          </a>
        ),
      },
      {
        key: "5-5",
        icon: <MinusOutlined style={{ transform: "rotate(90deg)" }} />,
        label: (
          <a href="/report/months-without-sales" rel="noopener noreferrer">
            Months without sales
          </a>
        ),
      },
      {
        key: "5-6",
        icon: <MinusOutlined style={{ transform: "rotate(90deg)" }} />,
        label: (
          <a href="/report/transaction-report" rel="noopener noreferrer">
            Transaction report
          </a>
        ),
      },
    ],
  },
];

const selfServiceItems = [
  {
    key: "1",
    icon: <img src={tokenIcon} alt="" />,
    label: (
      <a href="/home" rel="noopener noreferrer">
        Home
      </a>
    ),
  },
  {
    key: "2",
    icon: <img src={boltIcon} alt="" />,
    label: (
      <a href="/self-service-special-tokens" rel="noopener noreferrer">
        Special Tokens
      </a>
    ),
  },
  {
    key: "3",
    icon: <img src={reportIcon} alt="" />,
    label: (
      <a href="/self-service-report" rel="noopener noreferrer">
        Report
      </a>
    ),
  },
];

 
const ContentLayout: FC<ContentLayoutProps> = ({ children, headerName, iconName }) => {
  const savedState = getSavedState(localStorageKeys.EmsUser);
  const userName = savedState?.data?.fullName;
  const userType = savedState?.data?.userTypeEnumValue ||  USER_TYPE.ADMIN;
  
 

  const getInitials = (name: string) => {
    if (!name) return "";
    const nameParts = name.split(" ");
    const initials = nameParts.map((part) => part.charAt(0)).join("");
    return initials.toUpperCase();
  };

  const userInitials = getInitials(userName);

  return (
    <>
      {userType === USER_TYPE.SELF_SERVICE_ADMIN ? (
        <SelfServiceContentLayout
          items={selfServiceItems}
          headerName={headerName}
          iconName={iconName}
          savedState={savedState}
          userInitials={userInitials}
        >
          {children}
        </SelfServiceContentLayout>
      ) : (
        <AdminContentLayout
          items={items}
          reportItems={reportItems}
          headerName={headerName}
          iconName={iconName}
          savedState={savedState}
          userInitials={userInitials}
        >
          {children}
        </AdminContentLayout>
      )}
    </>
  );
};

export default ContentLayout;
